import ms from 'ms';

const EXPERTS = {
  default: {
    name: '',
    photoUrl: 'https://cdn.guuru.com/assets/logo/avatar.png',
  },
  preInactiveDays: 15,
  expertInactiveDays: 30,
  isInactive: (lastAcceptedAt : Date) => (
    Date.now() > lastAcceptedAt.getTime() + EXPERTS.expertInactiveDays * ms('1d')
  ),
  mapBucket: (bucket: string, lastAcceptedAt: Date) => {
    if (bucket === 'aboveThreshold') {
      if (!lastAcceptedAt) {
        return 'inactive';
      }
      const isInactive = EXPERTS.isInactive(lastAcceptedAt);
      return isInactive ? 'inactive' : 'active';
    }
    return bucket;
  },
} as const;

// eslint-disable-next-line import/prefer-default-export
export { EXPERTS };
